import script from "./DocumentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&setup=true&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=1906c5bf&lang=css"

const __exports__ = script;

export default __exports__